import React, { useState } from 'react';
import { MessageCircle, Phone, MapPin, Clock, Mail, Building, Users, Award, Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

const ContactPage = () => {
  const [selectedOffice, setSelectedOffice] = useState(0);

  const handleWhatsAppClick = (message = '') => {
    const defaultMessage = message || 'Hello, I would like to get in touch with NPSH Developers for a consultation.';
    window.open(`https://wa.me/919884611368?text=${encodeURIComponent(defaultMessage)}`, '_blank');
  };

  const handlePhoneClick = (phone) => {
    window.open(`tel:${phone}`, '_blank');
  };

  const offices = [
  {
    id: 1,
    name: "Head Office",
    address: "25, Katabomman Street, Virugambakkam, Chennai - 600092",
    phone: "+91 98846 11368", // Use your actual contact number
    whatsapp: "+91 98846 11368",
    email: "md@npshdevelopers.in",
    email: "md@npshdevelopers.in",
    hours: "Mon - Sat: 9:00 AM - 6:00 PM",
    // Map of Virugambakkam
    mapUrl:
     "https://www.google.com/maps?q=25+Katabomman+Street,+Virugambakkam,+Chennai,+600092&output=embed",

    type: "primary"
  },
  {
    id: 2,
    name: "Anna Nagar Branch",
    address: "O-2, Ground floor, K108/2, Bougainvilla Apartments, 16th Street, Anna Nagar East, Chennai - 600102",
    phone: "+91 98846 11368", // Branch number, adjust if needed
    whatsapp: "+91 98846 11368",
    email: "md@npshdevelopers.in",
    email: "manager@npshdevelopers.in",
    hours: "Mon - Sat: 9:30 AM - 6:00 PM",
    // Map roughly centered at Anna Nagar East 16th Street
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.8019833227667!2d80.2223125!3d13.0875427!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52642ab82c096f%3A0x3c2dc6953c08aabb!2s16th%20St%2C%20Anna%20Nagar%20East%2C%20Chennai%2C%20Tamil%20Nadu%20600102!5e0!3m2!1sen!2sin!4v1690967432513!5m2!1sen!2sin",
    type: "branch"
  }
];


  const quickActions = [
    {
      title: "Schedule Site Visit",
      description: "Book a visit to our ongoing or completed projects",
      icon: Building,
      action: () => handleWhatsAppClick("Hello, I would like to schedule a site visit to your projects.")
    },
    {
      title: "Free Consultation",
      description: "Get expert advice on your construction needs",
      icon: Users,
      action: () => handleWhatsAppClick("Hello, I would like to book a free consultation session.")
    },
    {
      title: "Request Brochure",
      description: "Download detailed brochures of our projects",
      icon: Award,
      action: () => handleWhatsAppClick("Hello, I would like to request brochures for your projects.")
    }
  ];

  const socialMedia = [
    { name: "Facebook", icon: Facebook, url: "https://facebook.com/npsh.developers", color: "hover:text-blue-600" },
    { name: "Instagram", icon: Instagram, url: "https://instagram.com/npsh.developers", color: "hover:text-pink-600" },
    { name: "LinkedIn", icon: Linkedin, url: "https://linkedin.com/company/npsh-developers", color: "hover:text-blue-700" },
    { name: "YouTube", icon: Youtube, url: "https://youtube.com/npsh.developers", color: "hover:text-red-600" }
  ];

  const certifications = [
    "RERA Registered",
    "ISO 9001:2015 Certified"
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-yellow-50 to-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl lg:text-6xl font-bold text-yellow-600 mb-6">
              Get In Touch
            </h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Ready to start your dream project? We're here to help you every step of the way. 
              Connect with us through WhatsApp for instant response.
            </p>
          </div>

          {/* Primary CTA */}
          <div className="text-center mb-16">
            <button
              onClick={() => handleWhatsAppClick()}
              className="inline-flex items-center px-12 py-6 bg-yellow-600 hover:bg-yellow-700 text-white text-2xl font-bold rounded-2xl transition-all duration-300 transform hover:scale-105 shadow-2xl hover:shadow-3xl animate-pulse-glow"
            >
              <MessageCircle className="mr-4 h-8 w-8" />
              Chat with Us on WhatsApp
            </button>
            <p className="text-gray-600 mt-4 text-lg">
              Get instant responses • Available 9 AM - 6 PM • No forms to fill
            </p>
          </div>
        </div>
      </section>

      {/* Quick Actions */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-yellow-600 mb-4">Quick Actions</h2>
            <p className="text-lg text-gray-600">Choose what you'd like to do and we'll connect you instantly</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {quickActions.map((action, index) => {
              const IconComponent = action.icon;
              return (
                <div
                  key={index}
                  onClick={action.action}
                  className="bg-white p-8 rounded-2xl shadow-lg border-2 border-gray-100 hover:border-yellow-600 transition-all duration-300 cursor-pointer group hover:shadow-xl transform hover:scale-105"
                >
                  <div className="w-20 h-20 bg-yellow-100 group-hover:bg-yellow-600 rounded-2xl flex items-center justify-center mx-auto mb-6 transition-colors duration-300">
                    <IconComponent className="h-10 w-10 text-yellow-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 group-hover:text-yellow-600 transition-colors duration-200 text-center">
                    {action.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-center">{action.description}</p>
                  <div className="mt-6 text-center">
                    <span className="inline-flex items-center text-yellow-600 font-medium group-hover:text-yellow-700">
                      Connect Now <MessageCircle className="ml-2 h-4 w-4" />
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Office Locations */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-yellow-600 mb-4">Our Offices</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Visit us at any of our conveniently located offices across Chennai
            </p>
          </div>

          {/* Office Selector */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {offices.map((office, index) => (
              <button
                key={office.id}
                onClick={() => setSelectedOffice(index)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                  selectedOffice === index
                    ? 'bg-yellow-600 text-white shadow-lg transform scale-105'
                    : 'bg-white text-gray-700 border-2 border-gray-200 hover:border-yellow-600 hover:text-yellow-600'
                }`}
              >
                {office.name}
              </button>
            ))}
          </div>

          {/* Selected Office Details */}
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div className="space-y-8">
              <div className="bg-gradient-to-br from-yellow-50 to-white p-8 rounded-2xl border-2 border-yellow-100">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-yellow-600 rounded-2xl flex items-center justify-center mr-4">
                    <Building className="h-8 w-8 text-white" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-yellow-600">{offices[selectedOffice].name}</h3>
                    {offices[selectedOffice].type === 'primary' && (
                      <span className="inline-block bg-yellow-600 text-white px-3 py-1 rounded-full text-sm font-medium mt-1">
                        Head Office
                      </span>
                    )}
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start">
                    <MapPin className="h-6 w-6 text-yellow-600 mr-4 mt-1 flex-shrink-0" />
                    <div>
                      <p className="font-semibold text-gray-800 mb-1">Address</p>
                      <p className="text-gray-600 leading-relaxed">{offices[selectedOffice].address}</p>
                    </div>
                  </div>

                  <div className="flex items-center">
                    <Phone className="h-6 w-6 text-yellow-600 mr-4 flex-shrink-0" />
                    <div>
                      <p className="font-semibold text-gray-800 mb-1">Phone</p>
                      <button
                        onClick={() => handlePhoneClick(offices[selectedOffice].phone)}
                        className="text-yellow-600 hover:text-yellow-700 font-medium"
                      >
                        {offices[selectedOffice].phone}
                      </button>
                    </div>
                  </div>

                  <div className="flex items-center">
                    <MessageCircle className="h-6 w-6 text-yellow-600 mr-4 flex-shrink-0" />
                    <div>
                      <p className="font-semibold text-gray-800 mb-1">WhatsApp</p>
                      <button
                        onClick={() => handleWhatsAppClick(`Hello, I would like to contact your ${offices[selectedOffice].name}.`)}
                        className="text-yellow-600 hover:text-yellow-700 font-medium"
                      >
                        {offices[selectedOffice].whatsapp}
                      </button>
                    </div>
                  </div>

                  <div className="flex items-center">
                    <Mail className="h-6 w-6 text-yellow-600 mr-4 flex-shrink-0" />
                    <div>
                      <p className="font-semibold text-gray-800 mb-1">Email</p>
                      <a
                        href={`mailto:${offices[selectedOffice].email}`}
                        className="text-yellow-600 hover:text-yellow-700 font-medium"
                      >
                        {offices[selectedOffice].email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center">
                    <Clock className="h-6 w-6 text-yellow-600 mr-4 flex-shrink-0" />
                    <div>
                      <p className="font-semibold text-gray-800 mb-1">Office Hours</p>
                      <p className="text-gray-600">{offices[selectedOffice].hours}</p>
                    </div>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => handleWhatsAppClick(`Hello, I would like to visit your ${offices[selectedOffice].name}. Please provide directions.`)}
                    className="w-full inline-flex items-center justify-center px-6 py-3 bg-yellow-600 hover:bg-yellow-700 text-white font-semibold rounded-lg transition-all duration-300"
                  >
                    <MessageCircle className="mr-2 h-5 w-5" />
                    Get Directions via WhatsApp
                  </button>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="bg-gray-100 rounded-2xl overflow-hidden border-4 border-yellow-100 h-96 lg:h-full min-h-[400px]">
              <iframe
                src={offices[selectedOffice].mapUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`${offices[selectedOffice].name} Location`}
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications & Social Media */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Certifications */}
            <div className="text-center">
              <h3 className="text-2xl font-bold text-yellow-600 mb-8">Our Certifications</h3>
              <div className="grid grid-cols-2 gap-4">
                {certifications.map((cert, index) => (
                  <div
                    key={index}
                    className="bg-white p-6 rounded-xl shadow-md border-2 border-gray-100 hover:border-yellow-600 transition-all duration-300"
                  >
                    <Award className="h-8 w-8 text-yellow-600 mx-auto mb-3" />
                    <p className="text-gray-800 font-medium text-sm">{cert}</p>
                  </div>
                ))}
              </div>
            </div>

            
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-yellow-600 to-yellow-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Your Dream Project Awaits
          </h2>
          <p className="text-xl text-yellow-100 mb-8 max-w-2xl mx-auto">
            Don't wait any longer. Connect with Chennai's most trusted construction company 
            and let's start building your future today.
          </p>
          <button
            onClick={() => handleWhatsAppClick("Hello, I'm ready to start my dream project with NPSH Developers. Let's discuss!")}
            className="inline-flex items-center px-8 py-4 bg-white text-yellow-600 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <MessageCircle className="mr-2 h-6 w-6" />
            Let's Build Together
          </button>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;